import React, { useState } from 'react';
import { XIcon, AlertCircleIcon } from 'lucide-react';
import { FormField } from '../../common/FormField';
interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
}
export const CreateChatbotModal = ({
  isOpen,
  onClose,
  onSave
}: Props) => {
  const [formData, setFormData] = useState({
    name: '',
    personality: '',
    maxTokens: 1500,
    temperature: 0.7,
    topP: 0.9
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }
    if (!formData.personality.trim()) {
      newErrors.personality = 'Personality description is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = () => {
    if (validateForm()) {
      onSave(formData);
    }
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-id="element-930">
      <div className="bg-surface-light border border-surface-border rounded-none w-full max-w-2xl" data-id="element-931">
        <div className="px-6 py-4 border-b border-surface-border flex items-center justify-between" data-id="element-932">
          <h2 className="text-lg font-medium text-white font-mono" data-id="element-933">
            Create New Chatbot
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-300 transition-colors" data-id="element-934">
            <XIcon size={20} data-id="element-935" />
          </button>
        </div>
        <div className="p-6 space-y-6" data-id="element-936">
          <FormField label="Chatbot Name" type="text" value={formData.name} onChange={value => setFormData(prev => ({
          ...prev,
          name: value
        }))} placeholder="e.g., Research Assistant" error={errors.name} required data-id="element-937" />
          <FormField label="Personality Description" type="textarea" value={formData.personality} onChange={value => setFormData(prev => ({
          ...prev,
          personality: value
        }))} placeholder="Describe how your chatbot should interact with users..." error={errors.personality} required tooltip="Define the chatbot's communication style, tone, and behavior" data-id="element-938" />
          <div className="space-y-6 bg-surface p-4 border border-surface-border" data-id="element-939">
            <h3 className="text-sm font-medium text-white font-mono" data-id="element-940">
              Initial Configuration
            </h3>
            <div className="space-y-4" data-id="element-941">
              <div data-id="element-942">
                <label className="block text-sm text-gray-400 mb-2" data-id="element-943">
                  Temperature
                </label>
                <div className="flex items-center gap-4" data-id="element-944">
                  <input type="range" min="0" max="1" step="0.1" value={formData.temperature} onChange={e => setFormData(prev => ({
                  ...prev,
                  temperature: parseFloat(e.target.value)
                }))} className="flex-1" data-id="element-945" />
                  <span className="text-sm text-gray-400 w-12 text-right" data-id="element-946">
                    {formData.temperature}
                  </span>
                </div>
              </div>
              <div data-id="element-947">
                <label className="block text-sm text-gray-400 mb-2" data-id="element-948">
                  Max Tokens
                </label>
                <input type="number" value={formData.maxTokens} onChange={e => setFormData(prev => ({
                ...prev,
                maxTokens: parseInt(e.target.value)
              }))} className="w-32 px-3 py-2 bg-surface border border-surface-border rounded-none text-white" data-id="element-949" />
              </div>
              <div data-id="element-950">
                <label className="block text-sm text-gray-400 mb-2" data-id="element-951">
                  Top P
                </label>
                <div className="flex items-center gap-4" data-id="element-952">
                  <input type="range" min="0" max="1" step="0.1" value={formData.topP} onChange={e => setFormData(prev => ({
                  ...prev,
                  topP: parseFloat(e.target.value)
                }))} className="flex-1" data-id="element-953" />
                  <span className="text-sm text-gray-400 w-12 text-right" data-id="element-954">
                    {formData.topP}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {Object.keys(errors).length > 0 && <div className="flex items-start gap-2 text-status-error text-sm" data-id="element-955">
              <AlertCircleIcon size={16} className="mt-0.5" data-id="element-956" />
              <p data-id="element-957">Please fix the errors above before creating</p>
            </div>}
        </div>
        <div className="px-6 py-4 border-t border-surface-border flex justify-between" data-id="element-958">
          <button onClick={onClose} className="px-4 py-2 text-sm text-gray-400 hover:text-gray-300 transition-colors" data-id="element-959">
            Cancel
          </button>
          <button onClick={handleSubmit} className="px-6 py-2 bg-accent hover:bg-accent-light text-white text-sm font-mono uppercase tracking-wide rounded-none transition-colors" data-id="element-960">
            Create Chatbot
          </button>
        </div>
      </div>
    </div>;
};